import { httpGet, httpPost, httpPut, httpDelete } from "../../utils/httpMethods";
import { SERVER_PATH } from "../restEndpoint";

const ROLE_URL = `${SERVER_PATH}/api/roles`;

export const getAllRoles = async () => {
  return await httpGet({ url: `${ROLE_URL}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const getRoleById = async (id) => {
  return await httpGet({ url: `${ROLE_URL}/${id}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const createRole = async (roleData) => {
  return await httpPost({ url: `${ROLE_URL}`, payload: roleData })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const updateRole = async (id, roleData) => {
  return await httpPut({ url: `${ROLE_URL}/${id}`, payload: roleData })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

export const deleteRole = async (id) => {
  return await httpDelete({ url: `${ROLE_URL}/${id}` })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err?.response;
    });
};

